export default __webpack_public_path__ + "static/media/Media.d7990dff.jpg";